module.exports = __webpack_public_path__ + "static/media/tiavina2.ef17be08.png";